import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { SHOPS_MAP_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { ShopsMapBlockScenarioContent } from '@front-platform/content-builder';
import {
  SHOPS_MAP_BLOCK_LOADING_VM,
  ShopsMapBlockDataSource,
  ShopsMapBlockViewModel,
} from './shops-map-block-view-model';

export function toShopsMapPreviewViewModel(
  content: ShopsMapBlockScenarioContent,
): ShopsMapBlockViewModel {
  return {
    shops: content.shops
      ? (content.shops as unknown as ShopsMapBlockViewModel['shops'])
      : undefined,
  };
}

@Injectable()
export class ShopsMapBlockPreviewDataSource implements ShopsMapBlockDataSource {
  readonly vm$: Observable<ShopsMapBlockViewModel> = previewScenarioForBloc$(
    SHOPS_MAP_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return SHOPS_MAP_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<ShopsMapBlockScenarioContent>(
        scenario,
        SHOPS_MAP_BLOCK_COMPONENT,
      );
      return content ? toShopsMapPreviewViewModel(content) : SHOPS_MAP_BLOCK_LOADING_VM;
    }),
  );
}
